
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cara-pembayaran/e-commerce",
      function () {
        return require("private-next-pages/cara-pembayaran/e-commerce.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cara-pembayaran/e-commerce"])
      });
    }
  